import React, { useState, useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { DataGrid } from "@mui/x-data-grid";

export default function UnderplayedByDeviceGrids({
  reports,
  devicesPerPage = 1,
}) {
  const grouped = useMemo(() => {
    const out = {};
    reports.forEach((r) => {
      if (r.expected_count > 0 && r.count < r.expected_count) {
        const device = r.device_name || r.device_id;
        out[device] = out[device] || [];
        out[device].push({
          video: r.video_title,
          date: new Date(r.date),
          count: r.count,
          expected: r.expected_count,
        });
      }
    });
    return out;
  }, [reports]);

  const deviceKeys = useMemo(() => Object.keys(grouped), [grouped]);
  const pageCount = Math.ceil(deviceKeys.length / devicesPerPage);
  const [page, setPage] = useState(1);
  const handlePage = (_, v) => setPage(v);

  const columns = [
    { field: "video", headerName: "Video Title", flex: 2, minWidth: 150 },
    { field: "date", headerName: "Date", type: "date", flex: 1, minWidth: 110 },
    { field: "count", headerName: "Count", type: "number", width: 80 },
    { field: "expected", headerName: "Expected", type: "number", width: 90 },
  ];

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {deviceKeys
          .slice((page - 1) * devicesPerPage, page * devicesPerPage)
          .map((device) => (
            <Box key={device}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                {device}
              </Typography>
              <Box sx={{ width: "100%" }}>
                <DataGrid
                  sx={{
                    width: "100%",
                    minHeight: 200,
                    "& .MuiDataGrid-columnSeparator": { display: "none" },
                    "& .MuiDataGrid-columnHeader:has(.MuiDataGrid-iconSeparator)":
                      { pointerEvents: "none" },
                  }}
                  autoHeight
                  rows={grouped[device].map((r, i) => ({ id: i, ...r }))}
                  columns={columns}
                  hideFooter
                  disableColumnMenu
                  disableSelectionOnClick
                  density="compact"
                />
              </Box>
            </Box>
          ))}
      </Box>

      {pageCount > 1 && (
        <Box sx={{ mt: 5, display: "flex", justifyContent: "center" }}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={handlePage}
            size="small"
          />
        </Box>
      )}
    </Box>
  );
}
